import React, { useEffect, useState } from "react";
import "./allfacebookfeeed.css";

const apiUrl = "https://cms.gammadda.lk/wp-json/wp/v2/posts?categories=15&per_page=10&_embed"; 

const AllFacebookFeeed = () => {
  
    const [projects, setProjects] = useState([]);
    const [lang, setLang] = useState("en");
  
    useEffect(() => {
      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => setProjects(data))
        .catch((error) => console.error("Error fetching projects:", error));
      const detectLanguage = () => {
        const el = document.querySelector(".nav-link");
        if (!el) return;
  
        const text = el.innerText;
        if (/[\u0D80-\u0DFF]/.test(text)) {
          setLang("si"); // Sinhala
        } else if (/[\u0B80-\u0BFF]/.test(text)) {
          setLang("ta"); // Tamil
        } else {
          setLang("en"); // Default
        }
      };
  
      const observer = new MutationObserver(detectLanguage);
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
  
      detectLanguage(); // Initial check
  
      return () => observer.disconnect();
  
  
    }, []);
  
    const getImageUrl = (post) => {
      if (post._embedded && post._embedded["wp:featuredmedia"] && post._embedded["wp:featuredmedia"][0]) {
        return post._embedded["wp:featuredmedia"][0].source_url;
      }
      return "default-image.jpg"; // Fallback image if no featured image is found
    };
  
    const titleStyle = {
      fontSize:
        lang === "si" ? "18px" : lang === "ta" ? "13px" : "23px",
      textDecoration: "none",
      color: "black",
      //lineHeight: "1.1",
    };
  
    const subtitleStyle = {
      fontSize:
        lang === "si" ? "25px" : lang === "ta" ? "20px" : "42px",
      textDecoration: "none",
      color: "black",
      //lineHeight: "1.1",
    };
  
    return (
  
      

    <div>
      <div id="projects" className="section-copy d-flex justify-content-center">
        <div className="container mx-2" style={{ paddingTop: "60px", maxWidth: '940px' }}>
          <div className="projects-title-wrapper d-flex justify-content-between align-items-center">
            <h2 className="projects-left p---heading-2" style={subtitleStyle}>Facebook</h2>        
          </div>
         
          <div className="row">
            {projects.length > 0 ? (
              projects.map((post) => {
                const { funded, totalrequiredfund } = post.acf || {};
                const fundedAmount = parseFloat(funded) || 0;
                const totalRequired = parseFloat(totalrequiredfund) || 1; // avoid division by 0
                const progress = Math.min((fundedAmount / totalRequired) * 100, 100);

                return (
                  <div className="col-md-4 col-sm-6 col-12 mb-3" key={post.id}>
                    <div className="card card-latest"  >
                        <div className="fb-embed-wrapper" style={{height:"295px"}}
                            dangerouslySetInnerHTML={{ __html: post.content.rendered }}
                        ></div>
                        {/* <a
                          className="d-flex justify-content-center gm---heading-3"
                          style={{ textDecoration: "none", color: "#f94322" }}
                        >
                          View Project
                        </a> */}
                    </div>
                 
                  </div>
                );
              })
            ) : (
              <p>Loading projects...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
    
};

export default AllFacebookFeeed;
